import { HomepageEntryPoint } from '../src/Homepage/HomepageEntryPoint';

// eslint-disable-next-line import/no-default-export
export default HomepageEntryPoint;
